<script>
import { Bar } from "vue-chartjs";
import ChartPluginDatalabels from "chartjs-plugin-datalabels";
import annotationPlugin from "../plugins/chartjs-plugin-annotation-0.5.7/chartjs-plugin-annotation";
import {getCurrencySymbol} from "./Utils";

export default {
  name: "BarChartV2",
  components: {
    ChartPluginDatalabels,
    annotationPlugin
  },
  props: {
    bar_chart_headers: [],
    bar_chart_data: {},
    /** @deprecated Prefer label props below; still merged as fallback when props are empty. */
    bar_chart_axes: {},
    metric_type: String(),
    metric_name: String(),
    avg_per_year: {},
    /** Parent drill-down handler (not named `onClick` — avoids Vue/DOM naming quirks). */
    chartClick: {
      type: Function,
      default: null
    },
    /**
     * Chart structure only (no domain semantics).
     * mixed_line_bar — line on counts scale + bars on amounts scale (dual Y).
     * bar_single_axis — one bar series on one Y-axis (expects counts[]; amounts ignored).
     */
    layout: {
      type: String,
      default: "mixed_line_bar",
      validator(v) {
        return v === "mixed_line_bar" || v === "bar_single_axis";
      }
    },
    /** Legend / tooltip name for the line series (counts axis, mixed_line_bar layout). */
    lineSeriesLabel: {
      type: String,
      default: ""
    },
    /** Legend / tooltip name for the bar series (amounts axis, mixed_line_bar layout). */
    barSeriesLabel: {
      type: String,
      default: ""
    },
    /** Counts Y-axis scale title (mixed_line_bar). Resolved before legacy axes. */
    countsAxisTitle: {
      type: String,
      default: ""
    },
    /** Amounts Y-axis scale title (mixed_line_bar). */
    amountsAxisTitle: {
      type: String,
      default: ""
    },
    /** X-axis scale title. */
    xAxisTitle: {
      type: String,
      default: ""
    }
  },
  extends: Bar,
  data() {
    return {
      datacollection: {
        labels: [],
        datasets: []
      },
      options: {
        /* annotation: {
          drawTime: "afterDraw",
          //events: ['click'],
          annotations: [
            {
              id: "hline",
              type: "line",
              mode: "horizontal",
              scaleID: "amounts",
              //value: this.avg_per_year.value,
              borderWidth: 2,
              borderColor: "rgb(255, 20, 99)",
              borderDash: [5, 5],
              radius: 0,
              label: {
                backgroundColor: "rgb(255, 231, 10)",
                fontColor: "black",
                //content: getCurrencySymbol() +this.numFormatter(this.avg_spend),
                enabled: true,
                position: "start"
              }
            }
          ]
        }, */
        /* onClick is set in loadChart() so it always closes over the component instance */
        plugins: {
          datalabels: {
            align: "end",
            anchor: "end",
            textAlign: "center",
            display: false,

            formatter: function(value, context) {
              let num = context.dataset.data[context.dataIndex];
              let lbl = "";

              //console.dir(context);

              if (context.datasetIndex == 1) {
                if (num > 999 && num < 1000000) {
                  num = (num / 1000).toFixed(1) + "K"; // convert to K for number from > 1000 < 1 million
                } else if (num > 1000000 && num < 1000000000) {
                  num = (num / 1000000).toFixed(1) + "M"; // convert to M for number from > 1 million
                } else if (num > 1000000000) {
                  num = (num / 1000000000).toFixed(1) + "B"; // convert to M for number from > 1 million
                }

                lbl = getCurrencySymbol() + num;
              }

              return lbl;
            },
            font: {
              weight: "bold",
              family: "verdana",
              size: "12"
            },

            padding: 12
            //formatter: Math.round
          }
        },
        scales: {
          yAxes: [
            {
              id: "counts",
              position: "right",
              display: true,
              ticks: {
                beginAtZero: true
                //fontColor: "#FFFFFF",
                /* callback: (value, index, values) => {
                  return (
                    "#" + value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  );
                } */
              },
              gridLines: {
                color: "#424242",
                display: false
              }
            },
            {
              id: "amounts",
              ticks: {
                display: true,
                mirror: false,
                /* Without this, a single large bar (~10M) makes Chart.js zoom tightly and
                   emit tiny fractional steps (9999999.2 … 10000000.8). */
                beginAtZero: true,
                maxTicksLimit: 8,
                fontSize: 12,
                fontFamily: "verdana",
                fontWeight: "bold",
                fontColor: "grey",

                callback: (value, index, values) => {
                  if (this.metric_name === "total_amount") {
                    const num = Number(value);
                    if (!Number.isFinite(num)) {
                      return value;
                    }
                    /* Use at least one decimal for K/M so adjacent ticks (e.g. 10.0M–10.8M)
                       do not all round to the same label with toFixed(0). */
                    if (num > 999 && num < 1000000) {
                      return (num / 1000).toFixed(1) + "K";
                    }
                    if (num >= 1000000 && num < 1000000000) {
                      return (num / 1000000).toFixed(1) + "M";
                    }
                    if (num >= 1000000000) {
                      return (num / 1000000000).toFixed(1) + "B";
                    }
                    return num;
                  }
                  const n = Number(value);
                  if (!Number.isFinite(n)) {
                    return value;
                  }
                  /* Large currency-style values when metric_name is doc_count (e.g. indigenous bars). */
                  if (Math.abs(n) >= 1000000) {
                    return (n / 1000000).toFixed(1).replace(/\.0$/, "") + "M";
                  }
                  if (Math.abs(n) >= 1000) {
                    return (n / 1000).toFixed(1).replace(/\.0$/, "") + "K";
                  }
                  return n;
                }
              },

              gridLines: {
                display: true
              }
            }
          ],
          xAxes: [
            {
              ticks: {
                display: true,
                //min: 10000,
                beginAtZero: true,
                fontColor: "grey",
                fontSize: 12,
                fontFamily: "verdana"
              },
              gridLines: {
                display: false
              }
            }
          ]
        },
        legend: {
          padding: 20,
          positon: "bottom",
          align: "end",
          display: true,
          labels: {
            usePointStyle: true,
            font: {
              boxWidth: 8,
              padding: 10,
              weight: "bold",
              family: "verdana",
              size: "8"
            }
          },

        },
        layout: {
          padding: {
            left: 20,
            right: 20,
            top: 20,
            bottom: 20
          }
        },
        responsive: true,
        maintainAspectRatio: false,

        tooltips: {
          backgroundColor: "#F6F8FC",
          borderColor: "rgb(255, 20, 99)",
          borderWidth: 1,
          borderRadius: 4,
          callbacks: {
            label: function(tooltipItem, data) {
              return data.datasets[tooltipItem.datasetIndex].label
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            }
          }
        }
      }
    };
  },

  watch: {
    /* avg_per_year(){
      this.avg_spend = this.avg_per_year.value;
    }, */
    // whenever search_terms prop changes, this function will run
    bar_chart_data() {
      this.loadChart();
    },
    bar_chart_axes() {
      this.loadChart();
    },
    layout() {
      this.loadChart();
    },
    lineSeriesLabel() {
      this.loadChart();
    },
    barSeriesLabel() {
      this.loadChart();
    },
    countsAxisTitle() {
      this.loadChart();
    },
    amountsAxisTitle() {
      this.loadChart();
    },
    xAxisTitle() {
      this.loadChart();
    }
  },
  created() {},

  mounted() {
    ////////////console.log("IN BAR CHART (LABELS)" + this.bar_chart_data.labels);
    ////////////console.log("IN BAR CHART (DATA)" + this.bar_chart_data.data[0]);
    this.loadChart();
  },

  methods: {
    numFormatter(num) {
      if (num > 999 && num < 1000000) {
        return (num / 1000).toFixed(1) + "K"; // convert to K for number from > 1000 < 1 million
      } else if (num >= 1000000 && num < 1000000000) {
        return (num / 1000000).toFixed(1) + "M"; // convert to M for number from > 1 million
      } else if (num >= 1000000000) {
        return (num / 1000000000).toFixed(1) + "B"; // convert to M for number from > 1 million
      } else if (num < 900) {
        return num; // if value < 1000, nothing to do
      }
    },

    /** First non-empty string among candidates (null/undefined/'' skipped). */
    pickFirstLabel(...candidates) {
      for (let i = 0; i < candidates.length; i++) {
        const v = candidates[i];
        if (v != null && String(v).length) {
          return String(v);
        }
      }
      return "";
    },

    loadChart() {
      const vm = this;
      this.options.onClick = (event, activeElements) => {
        let els = activeElements;
        const chart = vm.$data._chart;
        if ((!els || !els.length) && chart && typeof chart.getElementsAtEvent === "function") {
          els = chart.getElementsAtEvent(event) || [];
        }
        if (typeof vm.chartClick === "function") {
          vm.chartClick(event, els || []);
        }
      };

      const axes = this.bar_chart_axes || {};

      const lineLegend = this.pickFirstLabel(
        this.lineSeriesLabel,
        axes.countsLabel,
        "Number of notices"
      );
      const barLegend = this.pickFirstLabel(
        this.barSeriesLabel,
        axes.amountsLabel,
        "Total contracted amount"
      );

      const countsScaleTitle = this.pickFirstLabel(
        this.countsAxisTitle,
        axes.countsLabel,
        this.lineSeriesLabel,
        ""
      );
      const amountsScaleTitle = this.pickFirstLabel(
        this.amountsAxisTitle,
        axes.amountsLabel,
        this.barSeriesLabel,
        ""
      );
      const dualYAxisTitlesShown =
        countsScaleTitle.length > 0 && amountsScaleTitle.length > 0;

      const xTitleDefault = this.pickFirstLabel(this.xAxisTitle, axes.x, "");

      /** Single-axis bar layout: bar legend + Y-axis title */
      const singleBarLabel = this.pickFirstLabel(
        this.barSeriesLabel,
        this.countsAxisTitle,
        this.lineSeriesLabel,
        axes.primaryLabel,
        axes.countsLabel,
        "Values"
      );

      const barSingleAxis = this.layout === "bar_single_axis";

      if (barSingleAxis) {
        this.options.scales.yAxes = [
          {
            id: "counts",
            position: "left",
            display: true,
            ticks: {
              beginAtZero: true
            },
            gridLines: {
              display: true,
              color: "rgba(0,0,0,0.06)"
            },
            scaleLabel: {
              display: true,
              labelString: singleBarLabel,
              fontFamily: "verdana",
              fontSize: 11,
              fontColor: "grey"
            }
          }
        ];

        const xAxisTitleSingle = xTitleDefault;

        this.options.scales.xAxes[0].scaleLabel = xAxisTitleSingle
          ? {
              display: true,
              labelString: xAxisTitleSingle,
              fontFamily: "verdana",
              fontSize: 11,
              fontColor: "grey"
            }
          : { display: false };

        const barSeriesOnly = {
          yAxisID: "counts",
          type: "bar",
          fill: false,
          label: singleBarLabel,
          backgroundColor: "#12253a",
          borderWidth: 1,
          borderColor: "#12253a",
          data: this.bar_chart_data.counts,
          order: 1
        };
        this.datacollection.datasets = [barSeriesOnly];
        this.datacollection.labels = this.bar_chart_data.labels || [];

        this.options.tooltips = {
          intersect: false,
          mode: "index",
          displayColors: true,
          backgroundColor: "rgb(255,255,255)",
          borderColor: "#CDCDCD",
          padding: 20,
          xPadding: 10,
          yPadding: 10,
          caretSize: 0,
          borderWidth: 1,
          cornerRadius: 2,
          bodySpacing: 10,
          bodyFontFamily: "verdana",
          multiKeyBackground: "rgb(255,255,255)",
          callbacks: {
            label(tooltipItem, data) {
              let label = data.datasets[tooltipItem.datasetIndex].label;
              label = label + " in " + tooltipItem.xLabel;
              return `${label}: ${tooltipItem.yLabel}`;
            },
            title() {
              return null;
            },
            labelTextColor() {
              return "grey";
            }
          }
        };
      } else {
        const axisTitlesLegacy =
          axes.countsLabel != null &&
          axes.amountsLabel != null &&
          String(axes.countsLabel).length &&
          String(axes.amountsLabel).length;
        const showDualYTitles = dualYAxisTitlesShown || axisTitlesLegacy;

        this.options.scales.yAxes[0] = {
          id: "counts",
          position: "right",
          display: true,
          ticks: {
            beginAtZero: true
          },
          gridLines: {
            color: "#424242",
            display: false
          },
          scaleLabel: showDualYTitles
            ? {
                display: true,
                labelString: countsScaleTitle || lineLegend,
                fontFamily: "verdana",
                fontSize: 11,
                fontColor: "grey"
              }
            : { display: false }
        };
        this.options.scales.yAxes[1] = {
          id: "amounts",
          ticks: {
            display: true,
            mirror: false,
            beginAtZero: true,
            maxTicksLimit: 8,
            fontSize: 12,
            fontFamily: "verdana",
            fontWeight: "bold",
            fontColor: "grey",

            callback: (value, index, values) => {
              if (this.metric_name === "total_amount") {
                const num = Number(value);
                if (!Number.isFinite(num)) {
                  return value;
                }
                if (num > 999 && num < 1000000) {
                  return (num / 1000).toFixed(1) + "K";
                }
                if (num >= 1000000 && num < 1000000000) {
                  return (num / 1000000).toFixed(1) + "M";
                }
                if (num >= 1000000000) {
                  return (num / 1000000000).toFixed(1) + "B";
                }
                return num;
              }
              const n = Number(value);
              if (!Number.isFinite(n)) {
                return value;
              }
              if (Math.abs(n) >= 1000000) {
                return (n / 1000000).toFixed(1).replace(/\.0$/, "") + "M";
              }
              if (Math.abs(n) >= 1000) {
                return (n / 1000).toFixed(1).replace(/\.0$/, "") + "K";
              }
              return n;
            }
          },

          gridLines: {
            display: true
          },
          scaleLabel: showDualYTitles
            ? {
                display: true,
                labelString: amountsScaleTitle || barLegend,
                fontFamily: "verdana",
                fontSize: 11,
                fontColor: "grey"
              }
            : { display: false }
        };

        this.options.scales.xAxes[0].scaleLabel =
          xTitleDefault.length > 0
            ? {
                display: true,
                labelString: xTitleDefault,
                fontFamily: "verdana",
                fontSize: 11,
                fontColor: "grey"
              }
            : { display: false };

        var counts = {
          yAxisID: "counts",
          type: "line",
          label: lineLegend,
          fill: false,
          data: this.bar_chart_data.counts,
          lineTension: 0,
          stepped: true,
          borderWidth: 2,
          borderColor: "rgb(78, 184, 136)",
          pointBackgroundColor: "rgb(78, 184, 136)",
          pointBorderColor: "rgb(78, 184, 136)",
          order: 1
        };
        var amounts = {
          yAxisID: "amounts",
          type: "bar",
          fill: false,
          label: barLegend,
          backgroundColor: "#12253a",
          pointBackgroundColor: "white",

          borderWidth: 1,
          pointBorderColor: "#12253a",
          data: this.bar_chart_data.amounts,
          order: 3
        };
        this.datacollection.datasets[0] = counts;
        this.datacollection.labels = this.bar_chart_data.labels;
        this.datacollection.datasets[1] = amounts;

        this.options.tooltips = {
          intersect: false,
          mode: "index",
          displayColors: true,
          backgroundColor: "rgb(255,255,255)",
          borderColor: "#CDCDCD",
          padding: 20,
          xPadding: 10,
          yPadding: 10,
          caretSize: 0,
          borderWidth: 1,
          cornerRadius: 2,
          bodySpacing: 10,
          bodyFontFamily: "verdana",
          multiKeyBackground: "rgb(255,255,255)",
          callbacks: {
            label(tooltipItem, data) {
              var label = data.datasets[tooltipItem.datasetIndex].label;
              label = label + " in " + tooltipItem.xLabel;

              if (tooltipItem.datasetIndex === 1) {
                var value =
                  getCurrencySymbol() +
                  tooltipItem.yLabel
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",");

                return `${label}: ${value}`;
              }
              return `${label}: ${tooltipItem.yLabel}`;
            },

            title: function() {
              return null;
            },

            labelTextColor: function() {
              return "grey";
            }
          }
        };
      }
      //}

      /* this.options.annotation.annotations[0].value = this.avg_per_year.value;
      this.options.annotation.annotations[0].label.content =
        "Yearly Average $" + this.numFormatter(this.avg_per_year.value);

      this.addPlugin(ChartPluginDatalabels);
      this.addPlugin(annotationPlugin); */
      this.$refs.canvas.parentNode.style.height = "400px";
      //this.$refs.canvas.parentNode.style.width = "1000px";

      this.renderChart(this.datacollection, this.options);
    }
  },
  computed: {}
};
</script>
